import gsap from "gsap";

/** Headline + copy — aligned with `section-headline-gsap` / image-text feel */
export const OWNERS_CTA_DURATION = 1.05;
export const OWNERS_CTA_EASE = "power2.out";
export const OWNERS_CTA_Y = 20;

/** CTA: slightly longer + starts a beat later */
export const OWNERS_CTA_BUTTON_DURATION = 1.22;
export const OWNERS_CTA_BUTTON_DELAY = 0.14;

/**
 * Fade-in + slide-up for `.owners-cta__headline` + `.owners-cta__text` (same timing).
 * Button uses the same motion but longer duration and a short delay.
 *
 * @param {gsap.core.Timeline} timeline
 * @param {HTMLElement} section — `.owners-cta`
 * @param {number} [position=0] — timeline label
 */
export function appendOwnersCtaReveal(timeline, section, position = 0) {
  const headline = section.querySelector(".owners-cta__headline");
  const text = section.querySelector(".owners-cta__text");
  const button = section.querySelector(".owners-cta__button");
  const contentEls = [headline, text].filter(Boolean);

  if (!contentEls.length) {
    return false;
  }

  timeline.fromTo(
    contentEls,
    { autoAlpha: 0, y: OWNERS_CTA_Y },
    {
      autoAlpha: 1,
      y: 0,
      duration: OWNERS_CTA_DURATION,
      ease: OWNERS_CTA_EASE,
      force3D: true,
    },
    position,
  );

  if (button) {
    timeline.fromTo(
      button,
      { autoAlpha: 0, y: OWNERS_CTA_Y },
      {
        autoAlpha: 1,
        y: 0,
        duration: OWNERS_CTA_BUTTON_DURATION,
        ease: OWNERS_CTA_EASE,
        force3D: true,
      },
      position + OWNERS_CTA_BUTTON_DELAY,
    );
  }

  return true;
}
